import { z } from 'zod';
import { STOCK_LOCATION_KINDS, STOCK_MOVEMENT_TYPES } from '../constants/index.js';
import { decimalStringSchema, positiveDecimalStringSchema, uuidSchema } from './common.js';
/** Where stock sits: a warehouse or a vehicle, named by its own id. */
export const stockLocationSchema = z
    .object({
    kind: z.enum(STOCK_LOCATION_KINDS),
    warehouseId: uuidSchema.nullish(),
    vehicleId: uuidSchema.nullish(),
})
    .refine((v) => v.kind === 'warehouse' ? Boolean(v.warehouseId) && !v.vehicleId : Boolean(v.vehicleId) && !v.warehouseId, { message: 'validation.stockLocation' });
/** Current quantity of one product at one location. */
export const stockBalanceSchema = z.object({
    productId: uuidSchema,
    productSku: z.string(),
    productName: z.string(),
    unit: z.string(),
    /** Signed sum of every movement; a string so no precision is lost. */
    quantity: z.string(),
});
/** Load a vehicle from a warehouse, or return goods to it. */
export const createTransferSchema = z.object({
    fromWarehouseId: uuidSchema.nullish(),
    fromVehicleId: uuidSchema.nullish(),
    toWarehouseId: uuidSchema.nullish(),
    toVehicleId: uuidSchema.nullish(),
    lines: z
        .array(z.object({
        productId: uuidSchema,
        quantity: positiveDecimalStringSchema,
    }))
        .min(1)
        .max(200),
    reason: z.string().trim().max(500).nullish(),
});
/** Manual correction after a stock count, breakage or loss. */
export const createAdjustmentSchema = z.object({
    warehouseId: uuidSchema.nullish(),
    vehicleId: uuidSchema.nullish(),
    productId: uuidSchema,
    /** Signed and non-zero: negative writes stock off, positive adds it. */
    quantity: decimalStringSchema.refine((v) => Number.parseFloat(v) !== 0, {
        message: 'validation.nonZero',
    }),
    type: z.enum(['adjustment', 'write_off', 'purchase_in']).default('adjustment'),
    reason: z.string().trim().min(1).max(500),
});
export const stockMovementSchema = z.object({
    id: uuidSchema,
    type: z.enum(STOCK_MOVEMENT_TYPES),
    productId: uuidSchema,
    productSku: z.string(),
    productName: z.string(),
    quantity: z.string(),
    locationKind: z.enum(STOCK_LOCATION_KINDS),
    warehouseId: uuidSchema.nullable(),
    vehicleId: uuidSchema.nullable(),
    transferId: uuidSchema.nullable(),
    customerId: uuidSchema.nullable(),
    reason: z.string().nullable(),
    occurredAt: z.string(),
    createdByUserId: uuidSchema.nullable(),
});
export const stockMovementListQueryExtras = z.object({
    warehouseId: uuidSchema.optional(),
    vehicleId: uuidSchema.optional(),
    productId: uuidSchema.optional(),
    type: z.enum(STOCK_MOVEMENT_TYPES).optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
});
//# sourceMappingURL=stock.js.map